import { useFocusEffect, useRouter } from 'expo-router';
import { useCallback, useRef } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { headerItem } from '@/components/HeaderActions';
import { SuccessScreen } from '@/components/SuccessScreen';
import { Header } from '@/components/header';
import { VStack } from '@/components/ui/vstack';
import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { needsVerificationToSubmitInquiry, useAbility } from '@/hooks/useAbility';
import { segmentClient } from '@/util/analytics';

export default function NewQuestionSuccess() {
  const { navigate } = useRouter();

  const { bottom } = useSafeAreaInsets();

  const needsVerification = needsVerificationToSubmitInquiry(useAbility());

  const hasTrackedView = useRef(false);

  useFocusEffect(
    useCallback(() => {
      if (hasTrackedView.current) {
        return;
      }

      hasTrackedView.current = true;

      segmentClient.track(ANALYTICS_EVENTS.NEW_QUESTION_SUCCESS_VIEWED);
    }, [])
  );

  const ctaText = needsVerification ? 'Verify NPI' : 'Go to Inbox';

  const onCtaPress = useCallback(
    () => navigate(needsVerification ? '/npi-verification' : '/inbox'),
    [navigate, needsVerification]
  );

  return (
    <VStack className="flex-1 bg-primary-500 pb-8" style={{ paddingBottom: Math.max(bottom, 32) }}>
      <Header fill="brand" leftItems={[headerItem.close(onCtaPress)]} />
      <SuccessScreen
        heading="Thank you for your submission!"
        description={
          needsVerification
            ? "We've received your question and will route it to the appropriate expert. You can expect a response via email within 24 hours.\n\nIf you have any additional questions or concerns, please contact us at support@primum.co.\n\nTo gain access to everything Primum has to offer, please provide your NPI to verify your identity."
            : "We've received your question and will route it to the appropriate expert. You can expect a response within 24 hours.\n\nIf you have any additional questions or concerns, please contact us at support@primum.co"
        }
        riveAnimation="GAIN_CLARITY_LIGHT_GREEN"
        riveClassName="h-40 w-40"
        buttonText={ctaText}
        onButtonPress={onCtaPress}
      />
    </VStack>
  );
}
